import { queries } from "@/src/queries";
import { useSuspenseQuery } from "@tanstack/react-query";

export const useGetHome = () => {
  const query = useSuspenseQuery(queries.home.all);

  return query;
};
